<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex justify-content-between align-items-center mb-5">
    <div>
      <h2 class="text-3xl font-bold m-0 text-900">Nueva Venta</h2>
      <p class="text-500 m-0 text-sm mt-1">Registra un pedido manual</p>
    </div>
  </div>

  <div class="grid">

    <div class="col-12 md:col-7 lg:col-8">
      <div class="card bg-white border-1 border-gray-200 p-4 border-round-2xl shadow-none h-full">
        <h3 class="text-lg font-bold mb-4 text-900 flex align-items-center">
          <span class="bg-gray-900 text-white border-circle w-2rem h-2rem flex align-items-center justify-content-center text-sm mr-2">1</span>
          Seleccionar Productos
        </h3>

        <span class="p-fluid">
            <p-autoComplete
              [(ngModel)]="selectedProduct"
              [suggestions]="filteredProducts"
              (completeMethod)="filterProducts($event)"
              (onSelect)="onProductSelect($event)"
              field="name"
              placeholder="Buscar producto por nombre..."
              [minLength]="1"
              inputStyleClass="w-full text-lg shadow-none border-gray-300"
              class="w-full">
                <ng-template let-product pTemplate="item">
                    <div class="flex align-items-center gap-3 py-1">
                        <img [src]="product.image" style="width: 45px; height: 45px; object-fit: cover;" class="border-round-md shadow-1 bg-gray-50"/>
                        <div class="flex-1">
                            <div class="font-bold text-900">{{product.name}}</div>

                            <div class="flex flex-wrap gap-2 mt-1 text-xs" *ngIf="product.stockDetails && product.stockDetails.length > 0; else totalStock">
                                <span *ngFor="let s of product.stockDetails"
                                      class="px-2 py-1 border-round text-xs font-bold"
                                      [ngClass]="s.quantity > 0 ? 'bg-green-100 text-green-700' : 'bg-red-50 text-red-400 line-through'">
                                    {{s.sizeName}}: {{s.quantity}}
                                </span>
                            </div>
                            <ng-template #totalStock>
                                <div class="text-xs text-500">Stock Total: <span [class]="product.stock > 0 ? 'text-green-600 font-bold' : 'text-red-500'">{{product.stock}} u.</span></div>
                            </ng-template>
                        </div>
                    </div>
                </ng-template>
            </p-autoComplete>
        </span>

        <p-table [value]="cartItems" styleClass="mt-4" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 40%">Producto</th>
              <th style="width: 30%">Detalle</th>
              <th class="text-center">Cant.</th>
              <th class="text-right">Subtotal</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>
                <div class="flex align-items-center gap-3">
                  <img [src]="item.image" width="48" height="48" style="object-fit: cover" class="border-round-md bg-gray-50"/>
                  <span class="font-bold text-sm text-900">{{item.productName}}</span>
                </div>
              </td>
              <td>
                <div class="flex flex-wrap gap-2">
                  <span class="text-xs bg-gray-100 text-700 px-2 py-1 border-round font-medium">Talla: {{item.size}}</span>
                  <div class="flex align-items-center gap-1 text-xs bg-gray-100 text-700 px-2 py-1 border-round font-medium" *ngIf="item.color">
                    <i class="pi pi-palette mr-1 text-xs"></i>
                    {{item.color}}
                  </div>
                </div>
              </td>
              <td class="font-bold text-center text-900">{{item.quantity}}</td>
              <td class="text-right font-medium">{{item.subTotal | currency:'PEN':'symbol'}}</td>
              <td class="text-center">
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger hover:bg-red-50" (click)="removeItem(i)"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center text-500 py-6">
                <div class="flex flex-column align-items-center">
                  <i class="pi pi-shopping-bag text-4xl mb-3 text-300"></i>
                  <span>El carrito está vacío.</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="flex justify-content-end mt-4 pt-3 border-top-1 border-gray-100" *ngIf="cartItems.length > 0">
          <div class="text-right">
            <span class="text-500 block text-sm">Total prendas</span>
            <span class="text-2xl font-bold text-900">{{ totalAmount | currency:'PEN':'symbol' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-5 lg:col-4">
      <div class="card bg-white border-1 border-gray-200 p-4 border-round-2xl shadow-none h-full p-fluid flex flex-column gap-4">

        <div>
          <h3 class="text-lg font-bold mb-3 text-900 flex align-items-center">
            <span class="bg-gray-900 text-white border-circle w-2rem h-2rem flex align-items-center justify-content-center text-sm mr-2">2</span>
            Cliente
          </h3>
          <div class="field col-12 mb-2">
            <label class="font-semibold text-sm">Buscar cliente (opcional)</label>
            <p-autoComplete [(ngModel)]="selectedCliente" [suggestions]="filteredClientes" (completeMethod)="filterClientes($event)"
              (onSelect)="onClienteSelect($event.value)" optionLabel="nombreCliente" placeholder="Escribir nombre o celular..."
              [forceSelection]="true" [minLength]="1" inputStyleClass="w-full border-round-lg" class="w-full">
              <ng-template let-c pTemplate="item">
                <div class="flex align-items-center gap-2 py-1">
                  <span class="font-bold text-900">{{ c.nombreCliente }}</span>
                  <span class="text-xs text-500">{{ c.celular }}</span>
                  <span class="text-xs text-500" *ngIf="c.email">· {{ c.email }}</span>
                </div>
              </ng-template>
            </p-autoComplete>
            <small class="text-600 text-xs" *ngIf="selectedClienteEmail">
              Correo para boleta: {{ selectedClienteEmail }}
            </small>
          </div>
          <div class="formgrid grid">
            <div class="field col-12 mb-3">
              <label class="font-semibold text-sm">Nombre Completo</label>
              <input pInputText [(ngModel)]="clientName" class="border-round-lg w-full" />
            </div>
            <div class="field col-12 md:col-6 m-0 mb-3">
              <label class="font-semibold text-sm">N° Celular / WhatsApp</label>
              <input pInputText [(ngModel)]="clientPhone" class="border-round-lg w-full" />
            </div>
            <div class="field col-12 md:col-6 m-0 mb-3">
              <label class="font-semibold text-sm">Origen de Venta</label>
              <p-select [options]="origenVentaOptions" [(ngModel)]="origenVentaId" optionLabel="nombreOrigenVenta" optionValue="id" [showClear]="true" (onClear)="onOrigenVentaClear()" [placeholder]="saleOrigin || 'Seleccionar origen de venta'" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
          </div>
        </div>

        <div class="divider border-top-1 border-gray-200 m-0"></div>

        <div>
          <h3 class="text-lg font-bold mb-3 text-900 flex align-items-center">
            <span class="bg-gray-900 text-white border-circle w-2rem h-2rem flex align-items-center justify-content-center text-sm mr-2">3</span>
            Entrega
          </h3>

          <div class="field mb-3">
            <label class="text-sm font-semibold block mb-2">Tipo de Envío</label>
            <p-select [options]="tiposEnvio" [(ngModel)]="tipoEnvioId" (onChange)="onTipoEnvioChange()"
              optionLabel="nombreTipoEnvio" optionValue="id" placeholder="Seleccionar tipo de envío"
              styleClass="w-full border-round-lg" appendTo="body"></p-select>
          </div>

          <div class="formgrid grid">
            <div class="field col-12 md:col-6 mb-2">
              <label class="text-sm font-semibold">País</label>
              <p-select [options]="paises" [(ngModel)]="paisId" (onChange)="onPaisChange()" optionLabel="nombre" optionValue="id"
                placeholder="País" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
            <div class="field col-12 md:col-6 mb-2">
              <label class="text-sm font-semibold">Departamento</label>
              <p-select [options]="departamentos" [(ngModel)]="departamentoId" (onChange)="onDepartamentoChange()" optionLabel="nombre" optionValue="id"
                placeholder="Departamento" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
            <div class="field col-12 md:col-6 mb-2">
              <label class="text-sm font-semibold">Provincia</label>
              <p-select [options]="provincias" [(ngModel)]="provinciaId" (onChange)="onProvinciaChange()" optionLabel="nombre" optionValue="id"
                placeholder="Provincia" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
            <div class="field col-12 md:col-6 mb-2">
              <label class="text-sm font-semibold">Distrito</label>
              <p-select [options]="distritosUbigeo" [(ngModel)]="distritoId" (onChange)="onDistritoUbigeoChange()" optionLabel="nombre" optionValue="id"
                placeholder="Distrito" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
          </div>
          <div class="field col-12 mb-3">
            <label class="text-sm font-semibold">Dirección Exacta</label>
            <input pInputText [(ngModel)]="deliveryAddress" placeholder="Av. Principal 123..." class="border-round-lg w-full" />
          </div>

          <div class="formgrid grid bg-yellow-50 p-3 border-round-lg border-1 border-yellow-200 mt-3 mx-0" *ngIf="showDateTimePicker">
            <div class="col-12 text-sm font-bold text-yellow-800 mb-2 flex align-items-center"><i class="pi pi-calendar mr-2"></i> Programar Entrega</div>
            <div class="field col-7 m-0 pr-2" *ngIf="showDateTimePicker">
              <p-datepicker [(ngModel)]="scheduledDate" dateFormat="dd/mm/yy" appendTo="body" styleClass="w-full" placeholder="Fecha"></p-datepicker>
            </div>
            <div class="field col-5 m-0 pl-0" *ngIf="showDateTimePicker">
              <p-datepicker [(ngModel)]="scheduledTime" [timeOnly]="true" hourFormat="24" appendTo="body" styleClass="w-full" placeholder="Hora"></p-datepicker>
            </div>
          </div>
          <div class="field col-12 mt-2" *ngIf="selectedTipoEnvio && !showDateTimePicker">
            <label class="text-sm font-semibold text-yellow-800 flex align-items-center"><i class="pi pi-calendar mr-2"></i> Fecha de entrega</label>
            <p-datepicker [(ngModel)]="scheduledDate" dateFormat="dd/mm/yy" appendTo="body" styleClass="w-full border-round-lg" placeholder="Solo fecha"></p-datepicker>
          </div>

          <div class="field mt-3">
            <label class="text-sm font-semibold">Notas</label>
            <textarea pTextarea [(ngModel)]="notes" rows="2" placeholder="Ojo: Timbre malogrado..." class="w-full text-sm border-round-lg"></textarea>
          </div>
        </div>

        <div class="divider border-top-1 border-gray-200 m-0"></div>

        <div>
          <h3 class="text-lg font-bold mb-3 text-900 flex align-items-center">
            <span class="bg-gray-900 text-white border-circle w-2rem h-2rem flex align-items-center justify-content-center text-sm mr-2">4</span>
            Pago
          </h3>
          <div class="formgrid grid">
            <div class="field col-6">
              <label class="text-sm font-semibold">Método</label>
              <p-select [options]="paymentMethods" [(ngModel)]="paymentMethod" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
            <div class="field col-6">
              <label class="text-sm font-semibold">Tipo de moneda</label>
              <p-select [options]="tiposMoneda" [(ngModel)]="tipoMonedaId" optionLabel="nombreMoneda" optionValue="id" placeholder="Moneda" styleClass="w-full border-round-lg" appendTo="body"></p-select>
            </div>
            <div class="field col-12">
              <label class="text-sm font-semibold text-900">Descuento de prendas</label>
              <div class="flex align-items-center gap-2 flex-wrap">
                <p-inputNumber [(ngModel)]="discountValue" (ngModelChange)="calculateTotal()" (focus)="$any($event.target).select()" placeholder="0" inputStyleClass="border-round-lg" styleClass="flex-1" [style]="{'min-width':'120px'}"></p-inputNumber>
                <p-select [options]="discountTypes" [(ngModel)]="discountType" (onChange)="calculateTotal()" optionLabel="label" optionValue="value" styleClass="border-round-lg" [style]="{'width':'140px'}" appendTo="body"></p-select>
              </div>
            </div>
            <div class="field col-6">
              <label class="text-sm font-semibold">Envío {{ getMonedaSimbolo() }} <span class="text-xs text-500 font-normal">(informativo)</span></label>
              <p-inputNumber
                [(ngModel)]="deliveryPrice"
                mode="currency" currency="PEN" locale="es-PE"
                placeholder="0.00"
                inputStyleClass="font-bold border-round-lg w-full"
                [readonly]="false">
              </p-inputNumber>
            </div>
            <div class="field col-6">
              <label class="text-sm font-semibold">A Cuenta / Pagado</label>
              <p-inputNumber [(ngModel)]="amountPaid" mode="currency" currency="PEN" locale="es-PE" placeholder="0.00"
                inputStyleClass="border-round-lg w-full"></p-inputNumber>
            </div>

            <div class="field col-12 mt-3 p-3 bg-surface-50 border-round-lg border-1 border-200">
              <div class="flex justify-content-between text-sm text-600 mb-1"><span>Subtotal prendas</span><span class="font-bold text-900">{{ getSubtotalProductos() | currency:'PEN':'symbol' }}</span></div>
              <div class="flex justify-content-between text-sm mb-1" *ngIf="discountValue > 0">
                <span>Descuento</span><span class="font-bold text-red-600">- {{ getDescuentoCalculado() | currency:'PEN':'symbol' }}</span>
              </div>
              <div class="flex justify-content-between text-sm text-500 italic mb-1"><span>Costo envío</span><span>{{ deliveryPrice | currency:'PEN':'symbol' }} <span class="text-xs">(no suma al total)</span></span></div>
              <div class="flex justify-content-between text-sm mb-1"><span>Adelanto / Pagado</span><span class="font-medium text-900">{{ amountPaid | currency:'PEN':'symbol' }}</span></div>
              <div class="flex justify-content-between text-sm mb-2" *ngIf="getPendientePagar() >= 0"><span>Pendiente de pagar</span><span class="font-bold text-orange-600">{{ getPendientePagar() | currency:'PEN':'symbol' }}</span></div>
              <div class="flex justify-content-between align-items-center pt-2 border-top-1 border-200">
                <span class="font-bold text-900">Total a cobrar</span>
                <span class="text-xl font-bold text-900">{{ getPendientePagar() | currency:'PEN':'symbol' }}</span>
              </div>
            </div>
          </div>

          <button pButton [label]="isEditMode ? 'ACTUALIZAR VENTA' : 'GUARDAR VENTA'" icon="pi pi-check"
                  class="p-button-black p-button-lg w-full mt-4 font-bold border-round-lg shadow-2"
                  (click)="saveOrder()"
                  [disabled]="cartItems.length === 0"></button>
        </div>
        </div>
      </div>
    </div>
  </div>


<p-dialog header="Detalles del Producto" [(visible)]="showProductDialog" [modal]="true"
          [breakpoints]="{'960px': '75vw', '640px': '90vw'}" [style]="{width: '400px'}"
          [draggable]="false" [resizable]="false" styleClass="p-fluid">
  <div class="flex flex-column gap-3 pt-2" *ngIf="tempItem">
    <div class="text-center p-3 bg-gray-50 border-round-xl border-1 border-gray-100">
      <img [src]="tempItem.image" style="width: 100px; height: 100px; object-fit: contain;" class="mix-blend-multiply"/>
      <div class="font-bold text-xl text-900 mt-2">{{tempItem.productName}}</div>
    </div>

    <div class="field">
      <label class="font-bold text-sm">Talla</label>
      <p-select [options]="availableSizes"
                [(ngModel)]="tempItem.size"
                placeholder="Seleccionar"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                optionDisabled="disabled"
                (onChange)="updateMaxStock()"
                styleClass="w-full border-round-lg">
        <ng-template let-item pTemplate="item">
           <div class="flex justify-content-between align-items-center w-full">
               <span>{{item.label}}</span>
               <span class="text-xs p-1 border-round" [ngClass]="item.disabled ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'">
                   {{item.disabled ? 'Sin Stock' : 'Disponible'}}
               </span>
           </div>
        </ng-template>
      </p-select>
    </div>

    <div class="field">
      <label class="font-bold text-sm">Color</label>
      <p-select [options]="availableColors"
                [(ngModel)]="tempItem.color"
                optionLabel="name"
                optionValue="name"
                placeholder="Seleccionar color"
                appendTo="body"
                [editable]="true"
                styleClass="w-full border-round-lg">
        <ng-template let-item pTemplate="item">
           <div class="flex align-items-center gap-2">
               <div class="w-1rem h-1rem border-circle border-1 border-300"
                    [style.background-color]="item.hexCode"></div>
               <span>{{item.name}}</span>
           </div>
        </ng-template>
        <ng-template let-item pTemplate="selectedItem">
            <div class="flex align-items-center gap-2" *ngIf="item">
                <div class="w-1rem h-1rem border-circle border-1 border-300"
                     [style.background-color]="item.hexCode"></div>
                <span>{{item.name}}</span>
            </div>
        </ng-template>
      </p-select>
    </div>

    <div class="field">
      <label class="font-bold text-sm">Cantidad <span *ngIf="maxStock > 0" class="text-green-600 text-xs ml-2">(Máx: {{maxStock}})</span></label>
      <p-inputNumber [(ngModel)]="tempItem.quantity" [showButtons]="true" buttonLayout="horizontal"
                     incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                     [min]="1" [max]="maxStock"
                     inputStyleClass="text-center font-bold border-gray-300"
                     styleClass="border-round-lg overflow-hidden"></p-inputNumber>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text text-600" (click)="showProductDialog=false"></button>
      <button pButton label="Agregar al Pedido" icon="pi pi-check" class="p-button-black border-round-lg" (click)="addToCart()" [disabled]="!tempItem.size || maxStock === 0"></button>
    </div>
  </ng-template>
</p-dialog>